module.exports = __webpack_public_path__ + "img/48.c176ee2e.png";